// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { onAuthStateChanged, signOut } from "firebase/auth";
// import { auth } from "../firebase";
// import { resolveRole, getSessionInfo, clearSessionRole } from "../roles";

// export default function Nav() {
//   const [role, setRole] = useState("");
//   const [info, setInfo] = useState(() => getSessionInfo());

//   useEffect(() => {
//     const unsub = onAuthStateChanged(auth, async (u) => {
//       if (!u) {
//         setRole("");
//         setInfo(null);
//         clearSessionRole();
//         return;
//       }
//       const r = await resolveRole();
//       setRole(r || "");
//       setInfo(getSessionInfo());
//     });
//     return () => unsub();
//   }, []);

//   async function doSignOut() {
//     await signOut(auth);
//     setRole("");
//     setInfo(null);
//     clearSessionRole();
//   }

//   return (
//     <nav className="flex flex-wrap items-center gap-4 text-sm">
//       <Link to="/participant/login" className="hover:underline">Participant</Link>
//       <Link to="/volunteer/login" className="hover:underline">Volunteer</Link>
//       <Link to="/admin/login" className="hover:underline">Admin</Link>

//       {role === "volunteer" && (
//         <>
//           <Link to="/volunteer/teams" className="hover:underline">Add Teams</Link>
//           <Link to="/volunteer/checkin" className="hover:underline">Check-in</Link>
//         </>
//       )}

//       {role === "admin" && (
//         <>
//           <Link to="/admin/slots" className="hover:underline">Slots</Link>
//           <Link to="/admin/rooms" className="hover:underline">Rooms</Link>
//           <Link to="/admin/assign" className="hover:underline">Assign Seats</Link>
//           <Link to="/admin/volunteers" className="hover:underline">Volunteers</Link>
//           <Link to="/admin/admins" className="hover:underline">Manage Admins</Link>
//           <Link to="/admin/analytics" className="hover:underline">Analytics</Link>
//         </>
//       )}

//       {info?.email && (
//         <>
//           <span className="ml-auto text-xs text-gray-500">
//             {role ? `[${role}] ` : ""}{info.name ? `${info.name} · ` : ""}{info.email}
//           </span>
//           <button onClick={doSignOut} className="text-xs border rounded px-2 py-1 hover:bg-gray-50">
//             Sign out
//           </button>
//         </>
//       )}
//     </nav>
//   );
// }


import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase";
import { resolveRole, getSessionInfo, clearSessionRole } from "../roles";

export default function Nav() {
  const [role, setRole] = useState("");
  const [info, setInfo] = useState(() => getSessionInfo());

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      if (!u) {
        setRole("");
        setInfo(null);
        clearSessionRole();
        return;
      }
      const r = await resolveRole();
      setRole(r || "");
      setInfo(getSessionInfo());
    });
    return () => unsub();
  }, []);

  async function doSignOut() {
    await signOut(auth);
    setRole("");
    setInfo(null);
    clearSessionRole();
  }

  // pick home target
  const participantHome = role === "participant" ? "/participant/home" : "/participant/login";
  const volunteerHome   = role === "volunteer"   ? "/volunteer/home"   : "/volunteer/login";
  const adminHome       = role === "admin"       ? "/admin/home"       : "/admin/login";

  return (
    <nav className="flex flex-wrap items-center gap-4 text-sm">
      <Link to={participantHome} className="hover:underline">Participant</Link>
      <Link to={volunteerHome} className="hover:underline">Volunteer</Link>
      <Link to={adminHome} className="hover:underline">Admin</Link>

      {role === "volunteer" && (
        <>
          <Link to="/volunteer/teams" className="hover:underline">Add Teams</Link>
          <Link to="/volunteer/checkin" className="hover:underline">Check-in</Link>
        </>
      )}

      {role === "admin" && (
        <>
          {/* <Link to="/admin/slots" className="hover:underline">Slots</Link>
          <Link to="/admin/rooms" className="hover:underline">Rooms</Link>
          <Link to="/admin/assign" className="hover:underline">Assign Seats</Link> */}
          <Link to="/admin/volunteers" className="hover:underline">Volunteers</Link>
          {/* <Link to="/admin/admins" className="hover:underline">Manage Admins</Link> */}
          <Link to="/admin/analytics" className="hover:underline">Analytics</Link>
          {/* <Link to="/admin/exceptions" className="hover:underline">Email Exceptions</Link>
          <Link to="/admin/teams" className="hover:underline">Teams</Link> */}

        </>
      )}

      {info?.email && (
        <>
          <span className="ml-auto text-xs text-gray-500">
            {role ? `[${role}] ` : ""}{info.name ? `${info.name} · ` : ""}{info.email}
          </span>
          <button onClick={doSignOut} className="text-xs border rounded px-2 py-1 hover:bg-gray-50">
            Sign out
          </button>
        </>
      )}
    </nav>
  );
}
